import { mapFrom01Linear } from '@dsp-ts/math';
import * as stylex from '@stylexjs/stylex';
import { styles } from '../../styles';
import { jsx as _jsx } from "react/jsx-runtime";
export function KnobBaseThumb(_ref) {
  let {
    value01
  } = _ref;
  const angleMin = -145;
  const angleMax = 145;
  const angle = mapFrom01Linear(value01, angleMin, angleMax);
  return /*#__PURE__*/_jsx("div", {
    ...stylex.props(styles.knobBaseThumbWrapper),
    children: /*#__PURE__*/_jsx("div", {
      ...stylex.props(styles.knobBaseThumbWrapper2),
      style: {
        rotate: "".concat(angle, "deg")
      },
      children: /*#__PURE__*/_jsx("div", {
        ...stylex.props(styles.knobBaseThumb)
      })
    })
  });
}